<template>
    <div class='container' ref="containerBox" @scroll="handleScroll">
        <div ref="stickyBox" :class="[{ sticky: isSticky }, { box: !isSticky }]"
            :style="{ background: isSticky ? '#fff' : 'transparent' }">
            <titlePage :isSticky="isSticky" :scrollToTop="scrollToTop"></titlePage>
        </div>
        <div class='contentBox'>
            <div v-html="richContent" class="content"></div>
        </div>
        <fotterVue></fotterVue>
    </div>
</template>

<script>
import titlePage from '@/components/titlePage.vue';
import fotterVue from '@/components/fotter.vue';
export default {
    name: '',
    components: {
        titlePage,
        fotterVue,
    },
    data() {
        return {
            src: "require(`@/static/image/index/icon1.png`)",
            richContent: "",
            isSticky: false,
            stickyBoxTop: 0,
        };
    },
    computed: {},
    watch: {},
    created() {

    },
    mounted() {
        this.scrollToTop()
        this.getCon()
    },
    methods: {
        handleScroll(event) {
            const scrollTop = event.target.scrollTop
            this.isSticky = scrollTop > this.stickyBoxTop;
        },
        scrollToTop() {
            this.$refs.containerBox.scrollTop = 0;
        },
        getCon() {
            console.log(this.$route.query.type,'typetype'); 
            
            this.$api.index.getCon({ type: this.$route.query.type }).then(res => {
                if (res.code == 200) {
                    this.richContent = res.data || []
                }
            })
        }
    },
}
</script>
<style lang='scss' scoped>
.contentBox {
    background: linear-gradient(0deg, #F6F8FE 0%, #F6F8FE 78%, #CEEAFF 100%);
    margin-top: 60px;
    min-height: 55vh; 
}

.content {
    padding: 50px 0; 
}

::v-deep .el-carousel__container {
    height: 320px;
}
</style>